<div class="btn-group btn-group-sm reservations-view-toggle" role="group"
     aria-label="Reservations view">
  <a class="btn btn-outline-primary"
     [routerLink]="viewLink('upcoming')" routerLinkActive="active"
     ngbTooltip="View upcoming events which this customer is participating in"
     container="body">
    Upcoming Reservations
  </a>
  <a class="btn btn-outline-primary"
     [routerLink]="viewLink('bookings')" routerLinkActive="active"
     ngbTooltip="View event bookings made by or for this customer"
     container="body">
    Bookings
  </a>
</div>
